import React from 'react';
import Sidebar from './Sidebar';
import CommandPalette from './CommandPalette';

const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <main className="flex-1 overflow-auto relative z-0">
        {children}
      </main>
      <CommandPalette />
    </div>
  );
};

export default Layout;
